"use client";
import { en } from "./en.js";
import { no } from "./no.js";
import { useLanguage } from "./LocalizationProvider.js";
import { LocalizationProvider, useLocalization } from "./LocalizationProvider.js";
const translations = { en, no };
function translate(selector) {
  return (lang) => selector(translations[lang]);
}
const sliceTranslate = (selectSlice) => (selector) => (lang) => selector(selectSlice(translations[lang]));
function useTranslation(selectSlice) {
  const lang = useLanguage();
  if (selectSlice) {
    return selectSlice(translations[lang]);
  }
  return translations[lang];
}
export {
  LocalizationProvider,
  en,
  no,
  sliceTranslate,
  translate,
  translations,
  useLanguage,
  useLocalization,
  useTranslation
};
